"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class CommonApi extends runtime.BaseAPI {
    /**
     * stream_id刪除FileTable圖片
     */
    commonDeleteImagePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['guid'] != null) {
                queryParameters['guid'] = requestParameters['guid'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/DeleteImage`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * stream_id刪除FileTable圖片
     */
    commonDeleteImagePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.commonDeleteImagePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    commonGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    commonGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.commonGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 代碼下拉選單
     */
    commonGetCodeSettingsGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/GetCodeSettings`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 代碼下拉選單
     */
    commonGetCodeSettingsGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.commonGetCodeSettingsGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 圖片獲取
     */
    commonGetImageGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['id'] != null) {
                queryParameters['id'] = requestParameters['id'];
            }
            if (requestParameters['q'] != null) {
                queryParameters['q'] = requestParameters['q'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/GetImage`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * 圖片獲取
     */
    commonGetImageGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.commonGetImageGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 圖片獲取-NoToken
     */
    commonGetImageNoTokenGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['id'] != null) {
                queryParameters['id'] = requestParameters['id'];
            }
            if (requestParameters['q'] != null) {
                queryParameters['q'] = requestParameters['q'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/GetImageNoToken`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * 圖片獲取-NoToken
     */
    commonGetImageNoTokenGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.commonGetImageNoTokenGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 選單
     */
    commonGetMenuGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/GetMenu`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 選單
     */
    commonGetMenuGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.commonGetMenuGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 頁面基本訊息
     */
    commonGetPageInformationGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['menuId'] != null) {
                queryParameters['menuId'] = requestParameters['menuId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/GetPageInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 頁面基本訊息
     */
    commonGetPageInformationGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.commonGetPageInformationGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 代碼下拉選單(織品雲)
     */
    commonGetVCodeListGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/GetVCodeList`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 代碼下拉選單(織品雲)
     */
    commonGetVCodeListGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.commonGetVCodeListGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    commonRefreshTokenGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['oldToken'] != null) {
                queryParameters['oldToken'] = requestParameters['oldToken'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/Common/RefreshToken`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    commonRefreshTokenGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.commonRefreshTokenGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.CommonApi = CommonApi;
